import { apiClient } from './client';
import type { RegisterData, LoginResponse, User, UpdateProfileData, ChangePasswordData } from '../types/user';
import type { ApiResponse } from '../types/api';

export const authAPI = {
  register: (data: RegisterData) => 
    apiClient.post<any, ApiResponse<LoginResponse>>('/api/auth/register', data),
  
  login: (email: string, password: string, rememberMe?: boolean) => 
    apiClient.post<any, ApiResponse<LoginResponse>>('/api/auth/login', { email, password, rememberMe }),
  
  logout: () => 
    apiClient.post('/api/auth/logout'),
  
  getMe: () => 
    apiClient.get<any, ApiResponse<User>>('/api/users/profile'),
  
  updateProfile: (data: UpdateProfileData) =>
    apiClient.put<any, ApiResponse<User>>('/api/users/profile', data),
  
  changePassword: (data: ChangePasswordData) =>
    apiClient.put<any, ApiResponse<{ message: string }>>('/api/auth/password', data),
  
  uploadAvatar: (file: File) => {
    const formData = new FormData();
    formData.append('avatar', file);
    return apiClient.post<any, ApiResponse<{ avatarUrl: string }>>('/api/users/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  deleteAvatar: () =>
    apiClient.delete<any, ApiResponse<{ message: string }>>('/api/users/avatar'),
  
  refreshToken: (refreshToken: string) => {
    // Refresh endpoint not implemented on backend, return rejected promise
    return Promise.reject(new Error('Token refresh not supported - please login again'));
  },
};
